import { ModalFilesManagerComponent } from './ModalFilesManager.component';
import { enhance } from './ModalFilesManager.enhancers';

export const ModalFilesManager = enhance(ModalFilesManagerComponent);
